// extracted by mini-css-extract-plugin
export default {"features":"features_t9lD","featureSvg":"featureSvg_GfXr"};